// import 'babel-polyfill'
import 'es6-promise/auto'
import "@babel/polyfill"

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import VueLazyLoad from 'vue-lazyload'

import storage from './utils/storage.js'
import * as Api from './config/http.js';

import { redicectCheck, isSafeRedirect } from './utils/index.js'
import { apiBaseUrl } from './config/env.js'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')


Vue.use(VideoPlayer)
Vue.use(VueLazyLoad, {
  error: require('./assets/images/loading.png'),
  loading: require('./assets/images/loading.png')
})

var message = (text, type = 'success') => {
  Vue.prototype.$message({
    showClose: true,
    message: text,
    type: type,
    duration: 1000
  })
}
Vue.prototype.$msg = message;
Vue.prototype.$isSafeRedirect = isSafeRedirect;
Vue.config.productionTip = false
Vue.prototype.$api = Api;
Vue.prototype.$storage = storage;





router.beforeEach((to, from, next) => {

  if (to.meta.title) {
    if (store.state.config.shop_name) {
      document.title = to.meta.title + '-' + store.state.config.shop_name
    } else {
      document.title = to.meta.title
    }
  }

  const invitecode = (to.query && to.query.invitecode) || '';
  if (invitecode) {
    window.localStorage.setItem('invitecode', invitecode);
  }

  //redicectCheck()
	if(to.path == '/login') {
		window.localStorage.setItem('preUrl', from.fullPath)
	}

  next()
})
if(navigator.appName == "Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE",""))<=9){
  console.log('请升级浏览器')
}else{
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

